<template>
  <v-dialog v-model="targetDialog" max-width="800" persistent scrollable>
    <v-card>
      <v-card-title class="text-h5 grey lighten-4">
        ご利用上の注意事項
      </v-card-title>
      <v-card-text class="pt-3">
        <div>
          &emsp;本システムは、台風や集中豪雨から身を守るための防災気象情報をインターネットで提供しています。
          柏市や近隣の自治体に設置された観測機器（水位計、雨量計など）による観測情報をリアルタイムで表示します。ご利用の際は、以下の事項をご確認ください。
        </div>
        <div class="mt-4">・免責事項</div>
        <div class="ml-3">
          柏市は、本システムの情報を可能な限り正確に保つよう努めていますが、利用者が本システムの情報を使用して生じたいかなる損害についても責任を負いません。
          また、予告なしに本システムの情報を変更・削除したり、運用を中断・中止することがあります。
        </div>
        <div class="mt-3">・著作権</div>
        <div class="ml-3">
          本システムのコンテンツは、柏市やその他の団体,及び第三者の著作権により保護されています。
          著作権法で認められた「私的使用のための複製」や「引用」などを除き、無断で複製・転用することはできません。情報引用される際は出典を記載してください。
          <br />【記載例&emsp;出典：柏市管路内水位観測システム（https://kashiwa.riskma.jp/）】
        </div>
        <div class="mt-3">・表示される観測情報について</div>
        <div class="ml-3">
          本システムで提供する観測情報は、柏市が設置した水位観測機器の情報や、気象庁、国土交通省、千葉県、柏市消防局から提供される情報を表示しています。
          これらの情報は参考値であり、水防の警報発令を意味するものではありません。また、観測装置のメンテナンスや故障により、情報が欠測する場合があります。
        </div>
        <div class="mt-3">・異常値が表示される可能性について</div>
        <div class="ml-3">
          本システムの観測情報は、無人観測所から送られてくるデータを即時にお知らせするものです。
          そのため、観測機器の故障や通信異常により異常なデータが表示される可能性があります。ご承知おきください。
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close()">
          閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "NotesDialog",
  props: {
    dialog: {
      type: Boolean
    }
  },
  data() {
    return {
      targetDialog: false
    };
  },
  watch: {
    dialog(val) {
      this.targetDialog = val;
    }
  },
  computed: {
    //
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>
